// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "api";
import { API_AUTH } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints

export interface Icourses {
  title: string;
  levelId: string;
  topicId: string;
  status: string;
  self: boolean;
  page: number;
  duration: any;
  quizzLevel: string;
  chapterId?: string,
  type?: string,
}

export const coursesApi = createApi({
  reducerPath: "coursesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_AUTH,
    prepareHeaders: async (headers, { getState }) => {
      const token = await getToken();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllCourses: builder.mutation<any, Icourses>({
      query: (value) => {
        const {
          title = "",
          levelId = "",
          topicId = "",
          status = "",
          self = false,
          page = 1,
        } = value;

        return {
          url: `chapters?title=${title}&levelId=${levelId}&course=${topicId}&status=${status}&self=${self}&page=${page}`,
          method: "GET",
        };
      },
    }),
    getAllQuizz: builder.mutation<any, Icourses>({
      query: (value) => {
        const {
          title = "",
          levelId = "",
          topicId = "",
          status = "",
          self = false,
          page = 1,
          duration = "",
          quizzLevel = "",
          chapterId = ""
        } = value;

        return {
          url: `quizz?title=${title}&levelId=${levelId}&course=${topicId}&status=${status}&self=${self}&page=${page}&duration=${duration}&quizzLevel=${quizzLevel}&chapterId=${chapterId}`,
          method: "GET",
        };
      },
    }),
    getAllExercices: builder.mutation<any, Icourses>({
      query: (value) => {
        const {
          title = "",
          levelId = "",
          topicId = "",
          status = "",
          self = false,
          page = 1,
          type = "",
          chapterId = ""
        } = value;

        return {
          url: `exercises?title=${title}&levelId=${levelId}&course=${topicId}&status=${status}&self=${self}&page=${page}&type=${type}&chapterId=${chapterId}`,
          method: "GET",
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllCoursesMutation,
  useGetAllQuizzMutation,
  useGetAllExercicesMutation,
} = coursesApi;
